import { List } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
/**
 * CustomList component wraps Ant Design’s List component,
 * applying a default CSS class (`we-custom-list`) for consistent styling.
 *
 * @component
 * @param {Object} props – All props are forwarded to the underlying AntD List.
 * @returns {JSX.Element}
 */
const CustomList = ({ ...props }) => {
	const { dataSource, renderItem, ...rest } = props
	if (!Array.isArray(dataSource) || dataSource.length === 0) {
		return null
	}

	const customRenderItem = (item, index) => {
		if (item.t || item.d || item.a) {
			const { key, t, d, a, content, ...restItem } = item
			return (
				<List.Item key={key || index} {...restItem}>
					<List.Item.Meta avatar={a} title={t} description={d} />
					{content}
				</List.Item>
			)
		}
		if (renderItem) {
			return renderItem(item, index)
		}
		return <List.Item key={index}>{item}</List.Item>
	}

	return (
		<List
			className="we-custom-list"
			dataSource={dataSource}
			renderItem={customRenderItem}
			{...rest}
		/>
	)
}
CustomList.propTypes = {
	// Data source for the list items
	dataSource: PropTypes.array.isRequired,
	// Function to render each item (overridden if item has t/d/a)
	renderItem: PropTypes.func
}

export default CustomList
